import React, { Component } from 'react';
import { Form, Input } from 'antd';
import styles from '../../_style/index.less';
import { getFormList, setFormList } from './TableCellOperate';
import { PopoverTip } from '@/components';
import clazz from 'classnames';
import { getState } from '@@/store';
/**
 * desc 可编辑td
 * @params editable : 是否处于编辑状态
 * @params dataIndex : 字段Key
 * @params rowData : 行数据
 * @params form : 行form 用以获取当前行的修改值
 * */
class TableCellInput extends Component {
    constructor(props) {
        super(props);
        this.input = null;
        this.state = {};
    }
    cancelAutoComplate() {
        // const $input = document.querySelectorAll('.input_area .antd-input');
    }
    render() {
        const { editable } = this.props.td;
        return editable ? this.renderEditable() : this.renderNormal();
    }
    renderNormal() {
        return this.props.children;
    }
    changePopoverShow(validateItem) {
        const updateState = {};
        validateItem.errors && (updateState['validateMsg'] = validateItem.errors[0].message);
        updateState['validateState'] = !!validateItem.errors;
        return {
            msg: updateState.validateMsg || '',
            state: !!validateItem.errors,
        };
    }
    renderEditable() {
        const { dataIndex, rowData, form, checkRule, formKeyFn } = this.props.td;
        const dataKey = formKeyFn ? formKeyFn(rowData) : dataIndex;
        getFormList(rowData.goodsId) !== form && setFormList(rowData.goodsId, form);
        const checkRules = checkRule ? checkRule(rowData) : [];
        this.cancelAutoComplate();
        const { validateList } = getState().session;
        const { getFieldDecorator } = form;
        const price = rowData[dataKey] ? Number(`${rowData[dataKey]}`.split(',').join('')).toFixed(0) : '';
        let validateMsg = '';
        let validateState = false;
        const rowIndex = `${rowData.auctionSerialNumber - 1}`;
        if (validateList[rowIndex] && validateList[rowIndex][dataIndex]) {
            const validate = this.changePopoverShow(validateList[rowIndex][dataIndex]);
            validateMsg = validate.msg;
            validateState = validate.state;
        }
        return (<div className={styles.cell_editable}>
        <PopoverTip msg={validateMsg} direction={dataIndex === 'auctionPriceY' ? 'right' : 'top'} visible={validateState}>
          <Form.Item help={''} className={clazz(styles.place_hold, styles.editable, 'input_area')}>
            {getFieldDecorator(dataIndex, {
            validateFirst: true,
            initialValue: `${rowData[dataKey]}`.toLowerCase() === 'null' ? '0' : price,
            rules: [...checkRules],
        })(<Input style={{
            textAlign: 'center',
        }} ref={node => (this.input = node)}/>)}
          </Form.Item>
        </PopoverTip>
      </div>);
    }
}
export default TableCellInput;
